import type FileAttachment from "./file-attachment";
import type FileContent from "./file-content";

export default class File {
  constructor(
    public fileAttachment: FileAttachment,
    public fileContent: FileContent
  ) {}
}
